import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l8 10m-8 0l8 -10","key":"svg-0"}],["path",{"d":"M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2","key":"svg-1"}]]

const IconSuperscript = createReactComponent('outline', 'superscript', 'Superscript', __iconNode);

export default IconSuperscript;